import { html } from "lit-element";
import { DrawSVGTextBaseModule } from "../../ModuleBase/svg-text-base-module";

export class DrawAanhangerModule extends DrawSVGTextBaseModule {
	constructor(canvas) {
		super(canvas, "Aanhanger");

		this.name = "aanhanger";
		this.icon = svg_Aanhanger;
		this.svgTextIndex = 3;
	}
}

window.customElements.define("inspx-draw-aanhanger-module", DrawAanhangerModule);

const svg_Aanhanger = (text) => html`
<svg width="60" height="30" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
 <metadata id="metadata2959">image/svg+xml</metadata>
 <g>
  <title>Layer 1</title>
  <g id="svg_1">
   <rect stroke="#070707" y="-86.57219" x="1452.25943" height="60" width="100" id="rect4153" stroke-dashoffset="0" stroke-miterlimit="4" stroke-width="1.86056" fill="#b3b3b3" transform="matrix(0.40576328636127035,0,0,0.4641206988768415,-587.8382736379655,41.49850957856421) "/>
   <rect stroke="#070707" y="-78.23845" x="1465.59303" height="39.99921" width="74.99941" id="rect4155" stroke-dashoffset="0" stroke-miterlimit="4" stroke-width="1.86056" fill="#ffff00" transform="matrix(0.40576328636127035,0,0,0.4641206988768415,-587.8382736379655,41.49850957856421) "/>
   <path id="path4157" d="m42.23687,5.90346l16.1179,9.14163l-16.1179,9.14163" stroke-dashoffset="0" stroke-miterlimit="4" stroke-width="1.24037" fill="none" stroke="#000000"/>
   <text font-weight="bold" stroke="#021801" transform="matrix(0.29280141736295234,0,0,0.42602067662564336,-426.2354823684858,-281.44375994776044) " xml:space="preserve" text-anchor="middle" font-family="Sans-serif" font-size="20" id="svg_1" y="701.27753" x="1530.42711" fill-opacity="0.98844" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#000000">${text}</text>  
</g>
 </g>
</svg>`;
